module.exports = __webpack_public_path__ + "static/media/Hovata_White_Icon.33c27d80.png";